export default __webpack_public_path__ + "static/media/Tutorial-Step-4.f27d3338.jpg";